module.exports = __webpack_public_path__ + "img/forgot-pw.6a93a874.svg";